const baseSelector = (state) => state.superBatchGroupModule;

export const superBatchGroupModulesSelector = (state) =>
  baseSelector(state).selectedSuperBatchGroupModule;

export const batchDetailsSelector = (state) => baseSelector(state).batchDetails;
